(() => {
  const ROOT_SELECTOR = '[data-bundle-builder]';
  const SAVING_SELECTOR = '[data-bn-mobile-saving]';
  const SUBMIT_SELECTOR = '[data-bn-mobile-submit]';
  const SHIPPING_SELECTOR = '[data-bn-shipping]';
  const SHIPPING_SUCCESS_COPY = 'ENVÍO GRATIS CONSEGUIDO EN ESPAÑA PENINSULAR';

  let observedRoot = null;
  let observer = null;
  let frame = null;
  let repairing = false;

  const readCount = (element) => {
    const match = String(element?.textContent || '').match(/\d+/);
    return match ? Number.parseInt(match[0], 10) || 0 : 0;
  };

  const countLabel = (count) => {
    if (count <= 0) return '';
    if (count === 1) return '1 unidad';
    if (count === 2) return '2 unidades';
    return `PACK ${count}`;
  };

  const applyCountLabel = (root) => {
    const countElement = root.querySelector('[data-bundle-mobile-count]');
    if (!countElement) return;

    const count = readCount(countElement);
    const label = countLabel(count);
    if (countElement.textContent !== label) countElement.textContent = label;
    countElement.setAttribute('aria-label', label || 'Sin unidades seleccionadas');
  };

  const applySavingHighlight = (root) => {
    const savingElement = root.querySelector(SAVING_SELECTOR);
    if (!savingElement || savingElement.querySelector('.bn-saving-highlight')) return;

    const text = savingElement.textContent.trim();
    const match = text.match(/^(.*?)(AHORRAS\s+.+)$/i);
    if (!match) return;

    savingElement.replaceChildren(document.createTextNode(match[1]));
    const highlight = document.createElement('span');
    highlight.className = 'bn-saving-highlight';
    highlight.textContent = match[2];
    savingElement.append(highlight);
  };

  const applyShippingCopy = (root) => {
    const shipping = root.querySelector(SHIPPING_SELECTOR);
    const textElement = shipping?.querySelector('.bn-bundle-summary__shipping-text');
    if (!shipping || !textElement) return;

    const success = /ENVÍO GRATIS.*CONSEGUIDO|CONSEGUIDO.*ENVÍO GRATIS/i.test(textElement.textContent);
    shipping.toggleAttribute('data-bn-shipping-success', success);
    if (success) textElement.setAttribute('aria-label', SHIPPING_SUCCESS_COPY);
    else textElement.removeAttribute('aria-label');
  };

  const applyVisualFixes = (root = document.querySelector(ROOT_SELECTOR)) => {
    if (!root) return false;
    applyCountLabel(root);
    applySavingHighlight(root);
    applyShippingCopy(root);
    return true;
  };

  const enhancedElementsExist = (root) => Boolean(
    root.querySelector(SAVING_SELECTOR)
      && root.querySelector(SUBMIT_SELECTOR)
      && root.querySelector(SHIPPING_SELECTOR)
  );

  const bindObserver = (root) => {
    if (!root || root === observedRoot) return;
    observer?.disconnect();
    observedRoot = root;
    observer = new MutationObserver(queueEnsure);
    observer.observe(root, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  };

  const repairEnhancements = (root) => {
    if (repairing) return;
    repairing = true;

    root.querySelectorAll(`${SAVING_SELECTOR}, ${SUBMIT_SELECTOR}, ${SHIPPING_SELECTOR}`)
      .forEach((element) => element.remove());
    delete root.dataset.bnMobilePackEnhanced;

    document.dispatchEvent(new CustomEvent('shopify:section:load'));

    window.setTimeout(() => {
      repairing = false;
      const currentRoot = document.querySelector(ROOT_SELECTOR);
      bindObserver(currentRoot);
      applyVisualFixes(currentRoot);
    }, 160);
  };

  const ensureEnhanced = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.hasAttribute('data-bundle-not-ready')) return;

    bindObserver(root);
    if (!enhancedElementsExist(root)) repairEnhancements(root);
    else applyVisualFixes(root);
  };

  function queueEnsure() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      ensureEnhanced();
    });
  }

  const runBurst = () => {
    [0, 60, 220, 600, 1200, 2500].forEach((delay) => {
      window.setTimeout(ensureEnhanced, delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBurst, { once: true });
  } else {
    runBurst();
  }

  window.addEventListener('pageshow', runBurst);
  window.addEventListener('popstate', runBurst);
  document.addEventListener('shopify:section:load', () => window.setTimeout(ensureEnhanced, 0));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') runBurst();
  });

  window.setInterval(ensureEnhanced, 1000);
})();
